var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNumTimer3 = function SvgNumTimer3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF3",
    d: "M2.007 25.112H13.19V19.4H2.895v-3.816H13.19v-4.176H2.055V7.52h12.504q1.704 0 2.472.768.792.768.792 2.472v3.072q0 1.584-.744 2.28-.72.696-2.376.696v1.416q1.632 0 2.376.72t.744 2.256v4.56q0 1.68-.768 2.472-.768.768-2.496.768H2.007z"
  })));
};
export default SvgNumTimer3;